import { useQuery } from "@tanstack/react-query";
import { toastServerError } from "helpers";
import { ApiError, ApiServiceError, GetListResponse } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { ProductsListItem } from "../../product.types";
import { requestGetProductsByFilter } from "./getProductsByFilter.request";
import { GetProductsByFilterBody } from "./getProductsByFilter.types";

const useGetProductsByFilter = (
  requestBody: GetProductsByFilterBody,
  options?: QueryOptions<
    GetListResponse<ProductsListItem>,
    ApiServiceError<ApiError>
  >
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["products", "admin", "all", requestBody],
    queryFn: async () => await requestGetProductsByFilter(requestBody),
    onError: toastServerError,
    ...options
  });

  return { products: data?.data, meta: data?.meta, ...rest };
};

export default useGetProductsByFilter;
